import React from "react";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://twitter.com/JesseAnietie">
          <BsTwitter />
        </a>
      </div>
      <div>
        <FaFacebookF />
      </div>
      <div>
        <BsInstagram />
      </div>

      <div>
        <a href="https://www.linkedin.com/in/jesse-amos-54991024a/">
          <FaLinkedin />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
